<div
  [ngClass]="{ 'opacity-0': !loaded }"
  id="particles"
  class="z-0 relative ml-auto w-full md:w-[calc(100vw-18.750rem)] h-full bg-biggerContainerBgLight bgcv overflow-hidden"></div>
